'use client';
import { Box, Grid2, Link as MuiLink } from '@mui/material';
import CourseCard from '../cards/CourseCard';
import Link from 'next/link';

const CourseSection = ({ courses, username = null }) => {
  return (
    <Box>
      <Box sx={{ mt: 2 }}>
        <Grid2
          container
          gap={3}
          justifyContent={{
            xs: 'center',
            sm: 'center',
            md: courses.totalResults > 2 ? 'center' : 'right',
          }}>
          {courses.results?.map((item, index) => (
            <Grid2 key={index}>
              <CourseCard course={item} courseType="public-course" />
            </Grid2>
          ))}
        </Grid2>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        {courses.totalResults > 2 && (
          <MuiLink
            component={Link}
            href={`/courses?${username ? 'username=' + username : ''}`}
            variant="simpleLink">
            مشاهده بیشتر
          </MuiLink>
        )}
      </Box>
    </Box>
  );
};

export default CourseSection;
